"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WorkflowConsumer = _interopRequireDefault(require("./WorkflowConsumer"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint react/prefer-stateless-function: 0 */
var WorkflowStep = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(WorkflowStep, _React$Component);

  var _super = _createSuper(WorkflowStep);

  function WorkflowStep() {
    var _this;

    (0, _classCallCheck2.default)(this, WorkflowStep);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "doSetStepValidationResults", function (_ref) {
      var stepId = _ref.stepId,
          setStepExtendedState = _ref.setStepExtendedState,
          validationResults = _ref.validationResults;
      setStepExtendedState(stepId, 'validationResults', validationResults);
    });
    return _this;
  }

  (0, _createClass2.default)(WorkflowStep, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/(0, _jsx2.default)(_WorkflowConsumer.default, {}, void 0, function (_ref2) {
        var workflowDidMount = _ref2.workflowDidMount,
            currentStepId = _ref2.currentStepId,
            setStepExtendedState = _ref2.setStepExtendedState,
            unsetStepExtendedState = _ref2.unsetStepExtendedState,
            transitionToStep = _ref2.transitionToStep;

        if (workflowDidMount) {
          return /*#__PURE__*/(0, _jsx2.default)(_react.default.Fragment, {}, void 0, _react.default.Children.map(_this2.props.children, function (child) {
            var enrichedChild = /*#__PURE__*/_react.default.cloneElement(child, {
              workflowStepProps: _objectSpread({}, _this2.props),
              workflowStepCallbacks: {
                setStepValidationResults: function setStepValidationResults(validationResults) {
                  _this2.doSetStepValidationResults({
                    stepId: _this2.props.stepId,
                    setStepExtendedState: setStepExtendedState,
                    validationResults: validationResults
                  });
                }
              },
              workflowNavigation: {
                transitionToStep: transitionToStep
              }
            });

            return enrichedChild;
          }));
        }

        return null;
      });
    }
  }]);
  return WorkflowStep;
}(_react.default.Component);

WorkflowStep.displayName = 'WorkflowV2.Step';
var _default = WorkflowStep;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/WorkflowStep.js
// module id = 4514
// module chunks = 25